export default __webpack_public_path__ + "static/media/Front-Nabad-Gym-Jnah.6cdc544c.jpg";